module.exports = __webpack_public_path__ + "static/media/gif-dimen6.437469a5.gif";